import ContentInformation from './ContentInformation';
import Title from './Title';
import Subtitle from './Subtitle';

ContentInformation.Title = Title;
ContentInformation.Subtitle = Subtitle;

export { default } from './ContentInformation';
